<template>
  <section id="footer">
    <div class="container">
      <div class="row gy-5 mb-5">
        <div class="col text-left">
          <img
            :src="require('@/assets/images/logo-footer.png')"
            class="mb-5"
            alt=""
          />
          <p class="text-white">
            Never stop learning. Continuous development for you and your
            business.
          </p>
        </div>
        <div class="col-12 col-md text-left">
          <h5 class="mb-4 text-white">Quick Links</h5>
          <router-link :to="{ name: 'home' }">Home</router-link>
          <router-link :to="{ name: 'in-house-training' }">Untuk Perusahaan</router-link>
          <!-- <router-link :to="{name:'prodis'}">Promo & Diskon</router-link> -->
          <!-- <a href="">Literasi</a> -->
          <router-link :to="{ name: 'about-us' }">Tentang Kami</router-link>
          <router-link :to="{ name: 'privacy' }">Kebijakan Privasi</router-link>
          <router-link :to="{ name: 'termsofservice' }">Syarat dan Ketentuan</router-link>
        </div>
        <div class="col-12 col-md text-left">
          <h5 class="mb-4 text-white">Services</h5>
          <router-link :to="{ name: 'dilatih-insight' }" href=""
            >Dilatih Insight</router-link
          >
          <!-- <a href="">Dilatih Class</a>
          <a href="">Dilatih Workshop</a> -->
        </div>
        <div class="col-sm-12 col-md text-left">
          <h5 class="mb-4 text-white">Contact Info</h5>
          <p>
            Jl. Bandung Tempo Dulu No. 17 Kotabaru Parahyangan Kabupaten Bandung
            Barat Jawa Barat 40553
          </p>
          <p>08999906622</p>
          <p>085155077968</p>
          <a href="https://twitter.com/dilatihdotco" class="social-media"
            ><i class="fa-brands fa-twitter"></i
          ></a>
          <a href="https://www.instagram.com/dilatih.co/" class="social-media"
            ><i class="fa-brands fa-instagram"></i
          ></a>
          <a
            href="https://www.linkedin.com/company/dilatih-co/"
            class="social-media"
            ><i class="fa-brands fa-linkedin"></i
          ></a>
          <a href="https://www.facebook.com/MotekarEdukasi" class="social-media"
            ><i class="fa-brands fa-facebook"></i
          ></a>
        </div>
      </div>
      <p>© {{ year }} ALL RIGHTS RESERVED. PT Motekar Edukasi Indonesia</p>
    </div>
  </section>
</template>
<script>
export default {
  name: 'FooterLanding',
  data() {
    return { year: new Date().getFullYear() }
  },
}
</script>
